import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'headerParser',
    standalone: false
})
export class HeaderParserPipe implements PipeTransform {

  transform(value: string): any {
    return value.replace(/_/g, ' ');
  }

}
